import { t } from "i18next";

import { IButtonGroup } from "./interface";
import styles from "./styles";
import { ButtonEmpty } from "../ButtonEmpty";
import { ButtonPrimary } from "../ButtonPrimary";

export function ButtonsGroup({ cancelButtonHandler, rightButton }: IButtonGroup) {
  return (
    <styles.ButtonsGroupWrapper>
      <ButtonEmpty name={t("actions.cancel")} handler={cancelButtonHandler} />
      <ButtonPrimary
        name={rightButton.name}
        handler={rightButton.handler}
        iconRight={rightButton.iconRight}
        iconLeft={rightButton.iconLeft}
        color={rightButton.color}
        disabled={rightButton.disabled}
      />
    </styles.ButtonsGroupWrapper>
  );
}
